import { Button } from 'ca-ui';

export class AlertModal {
  constructor (vr, editor) {
    this.vr = vr;
    this.editor = editor;
    this.initializeModal();
  }

  initializeModal () {
    // generate div to use
    this.alertModalContainer = $('<div class="ca-vr_alert-modal-container"></div>');

    this.alertModalContent = $('<div class="ca-vr_alert-modal-content"></div>');
    this.alertModalContainer.append(this.alertModalContent);

    // generate success div
    this.alertModalIcon = $('<div class="ca-vr_alert-modal-icon"></div>');
    this.alertModalContent.append(this.alertModalIcon);

    // generate success state message
    this.alertModalMessage = $('<div class="ca-vr_alert-modal-message"></div>');
    this.alertModalContent.append(this.alertModalMessage);

    // generate cta group
    this.alertModalCTAGroup = $('<div class="ca-vr_alert-modal-cta-group"></div>');
    this.alertModalContent.append(this.alertModalCTAGroup);

    // generate buttons to add to group

    // append div to container
    this.vr.wrapper.append(this.alertModalContainer);
    this.hide();
  }

  show () {
    this.alertModalContainer.show();
    this.lockViewWhileModalIsOpen(true);
  }

  hide () {
    this.alertModalContainer.hide();
    this.lockViewWhileModalIsOpen(false);
  }

  lockViewWhileModalIsOpen (isModalShowing) {
    if (this.vr !== undefined && this.vr.panoViewer !== undefined) {
      if (isModalShowing) {
        this.vr.panoViewer.setUseZoom(false);
        this.vr.enableMove(false);
      } else {
        this.vr.panoViewer.setUseZoom(true);
        this.vr.enableMove(true);
      }
    }
  }

  setSuccessState (successState) {
    this.successState = successState;
    // empty success state icon from alert modal icon container
    $('.ca-vr_alert-modal-icon').empty();
    // remove success and error class from alertModalIcon
    this.alertModalIcon.removeClass('success error');
    if (successState === 'success') {
      this.successIcon = $('<i class="fas fa-check-circle"></i>');
      this.alertModalIcon.addClass('success');
    } else if (successState === 'error') {
      this.successIcon = $('<i class="fas fa-times-circle"></i>');
      this.alertModalIcon.addClass('error');
    } else if (successState === 'warning') {
      this.successIcon = $('<i class="fas fa-exclamation-triangle"></i>');
      this.alertModalIcon.addClass('warning');
    }
    this.alertModalIcon.append(this.successIcon);
  }

  setAlertMessage (alertMessage) {
    this.alertMessage = alertMessage;
    $('.ca-vr_alert-modal-message').empty();
    this.alertModalMessage.append(`<p>${alertMessage}</p>`);
    console.log(alertMessage);
  }

  setAlertCTAButtons (buttonOptions) {
    console.log(buttonOptions);
    $('.ca-vr_alert-modal-cta-group').empty();
    if (buttonOptions.buttonCount > 1) {
      // stub for now
      this.declineCTA = new Button({
        icon: buttonOptions.buttons[1].type === 'confirm' ? 'check' : 'times',
        label: buttonOptions.buttons[1].text
      });

      this.declineCTA.on('click', function () {
        this.hide();
      }.bind(this));

      this.declineCTA.el.addClass('decline');

      this.alertModalCTAGroup.append(this.declineCTA.el);

      this.confirmCTA = new Button({
        icon: buttonOptions.buttons[0].type === 'confirm' ? 'check' : 'times',
        label: buttonOptions.buttons[0].text
      });

      this.confirmCTA.on('click', function () {
        this.hide();
        if (buttonOptions.buttons[0].link) {
          window.open(buttonOptions.buttons[0].link, '_blank');
        }

        if (buttonOptions.buttons[0].onClick !== undefined) {
          buttonOptions.buttons[0].onClick.call();
        }
      }.bind(this));

      this.confirmCTA.el.addClass('confirm');

      this.alertModalCTAGroup.append(this.confirmCTA.el);
    } else {
      console.log('hopefully this should be running');
      console.log(buttonOptions.buttons[0].text);
      this.confirmCTA = new Button({
        icon: buttonOptions.buttons[0].type === 'confirm' ? 'check' : 'times',
        label: buttonOptions.buttons[0].text
      });

      this.confirmCTA.on('click', function () {
        this.hide();
      }.bind(this));

      this.confirmCTA.el.addClass('confirm');

      this.alertModalCTAGroup.append(this.confirmCTA.el);
    }
  }
}
